import {useEffect, useState} from 'react';
// @ts-ignore — JS module
import Connector from '@/api/agent';

/**
 * Renders just the semver portion of the backend's /version response.
 * Strips the trailing "-YYYY.MM.DD-HH.mm" build timestamp.
 */
const HeaderVersion = () => {
    const [version, setVersion] = useState<string | null>(null);

    useEffect(() => {
        let cancelled = false;
        Connector.apiProd
            .get('/version')
            .then((res: {data: unknown}) => {
                if (cancelled) return;
                const raw =
                    typeof res.data === 'string'
                        ? res.data
                        : (res.data as {version?: string})?.version ?? '';
                if (!raw) return;
                setVersion(raw.split('-')[0]);
            })
            .catch(() => {/* ignore — header just hides the version */});
        return () => {
            cancelled = true;
        };
    }, []);

    if (!version) return null;
    return <>v{version}</>;
};

export default HeaderVersion;
